'use strict';

const Accordion = {
    init: function () {
        const toggleButtons = document.querySelectorAll('.toggle-button');
        if (toggleButtons && toggleButtons.length > 0) {
            toggleButtons.forEach(button => {
                button.addEventListener('click', () => {
                    const toggleContent = button.parentElement.querySelector('.toggle-content');
                    const activeContent = document.querySelector('.toggle-content.active');

                    if (activeContent && activeContent !== toggleContent) {
                        activeContent.classList.remove('active');
                        activeContent.parentElement.querySelector('.toggle-button').classList.remove('active');

                        setTimeout(() => {
                            button.classList.add('active');
                            toggleContent.classList.add('active');
                        }, 300);
                    } else {
                        if (toggleContent) {
                            const isActive = toggleContent.classList.contains('active');
                            button.classList.toggle('active', !isActive);
                            toggleContent.classList.toggle('active', !isActive);
                        }
                    }
                });
            });
        }
    },
};

export default Accordion;